import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class AtrioBreadcrumbService {
    private subject = new Subject();
 
    sendBreadcrumb(breadcrumb: any) {
        this.subject.next(breadcrumb);
    }
 
    getBreadcrumb(): Observable<any> {
        return this.subject.asObservable();
    }
}